import React from "react";
import { Create, FileInput, FileField, SimpleForm, required, useNotify, useRedirect } from "react-admin";

const ImportOffices = props => {
  const notify = useNotify();
  const redirect = useRedirect();
  const onSuccess = data => {
    notify(`Файлът е качен успешно!`, { type: "success" });
    redirect(`/`);
  };
  const onError = () => {
    notify("Възникна грешка! Моля проверете формата на документа или опитайте по-късно.", { type: "warning" });
  };
  return (
    <Create
      mutationOptions={{ onSuccess, onError }}
      title="Качване на информация за офиси"
    >
      <SimpleForm>
        <FileInput
          placeholder="Добавете файл с  информация за офиси в XLS формат"
          label="Офиси"
          source="file"
          accept=".xls , .xlsx"
          validate={[required()]}
        >
          <FileField
            source="src"
            title="title"
            label={null}
          />
        </FileInput>
      </SimpleForm>
    </Create>
  );
};

export default ImportOffices;
